import { defineStore } from 'pinia'
import { cloneDeep } from 'lodash-es'
export interface TokenInfo {
  access_token: string
  enhance?: string
  expires_in?: number
  refresh_token?: string
  scope?: string
  token_type: string
}

export interface UserInfo {
  username: string
  password: string
  tokenInfo: TokenInfo
  rolesList?: string[]
}
export interface UserState {
  userInfo: UserInfo
  hideTokenExpiredPop: boolean
}

export const useUserStore = defineStore('main', {
  state: (): UserState => {
    return {
      userInfo: {
        username: '',
        password: '',
        tokenInfo: {
          token_type: '',
          access_token: '',
        },
        rolesList: [],
      },
      hideTokenExpiredPop: false, //token失效时，当前页面如果连续发出了多个请求，避免弹出多个登录提示弹框。初始化false，允许弹出。
    }
  },
  actions: {
    setHideTokenExpiredPop(state: boolean) {
      this.hideTokenExpiredPop = state
    },
    setUserInfo(userInfo: UserInfo) {
      this.userInfo = cloneDeep(userInfo)
      localStorage.setItem('userInfo', JSON.stringify(userInfo)) // 存储userInfo
    },
    refreshStore() {
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo) {
        const obj = JSON.parse(userInfo)
        this.userInfo = obj
      }
    },
    clearUserInfo() {
      this.userInfo = {
        username: '',
        password: '',
        tokenInfo: {
          token_type: '',
          access_token: '',
        },
        rolesList: [],
      }
      localStorage.removeItem('userInfo')
    },
  },
})
